// #124: the Finance guided assessment is kept on the server per assessment id
// (plus the signed-in user), so it survives socket reconnects. A new id starts
// a new assessment.
export const newCreditSessionId = () => (
  window.crypto?.randomUUID?.() || `cs-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
);

// Question turns of the guided assessment have no text of their own (the
// question lives in the card); send it as the turn's text so the server can
// rebuild an assessment it no longer holds from what the user sees.
export const historyForServer = (messages) => messages.map((message) => (
  !message.content && message.creditQuestionnaire?.question
    ? { ...message, content: message.creditQuestionnaire.question }
    : message
));

// The assessment id travels with the Finance answers, which are saved with the conversation: reopening
// the conversation — after a reload, on another device, or once the service is back after an outage —
// goes on with the same assessment on the server instead of starting a new one.
export const creditSessionIdOf = (messages) => {
  for (let i = (messages || []).length - 1; i >= 0; i -= 1) {
    const id = messages[i]?.creditSessionId;
    if (id) return id;
  }
  return null;
};
